<template>
  <div class="product-header">
    <div class="logo">
      <div class="left">
        <img src="image/product/icon_logo@2x.png" alt="">
        <span>亿航产品系列</span>
      </div>
      <div class="right">
        <wf-button size="large" type="text" plain icon="icon iconfont iconicon_enlarge" v-permission="'产品项系列管理-新增系列'" @click="addSeries" style="margin-right: 16px;">新建系列</wf-button>
        <wf-button size="large" type="primary" icon="icon iconfont iconicon_enlarge" @click="handlerClick" v-permission="'产品项管理-新增产品项'">新建产品项</wf-button>
      </div>
    </div>
    <div class="banner" @click="handlerClickBanner">
      <img src="image/product/bg_eh216g_banner@2x (1).png" alt="">
    </div>
    <div class="all">
      <span class="title">筛选</span>
      <div class="header-list">
        <div class="item" v-for="item in filterList" :key="item.value">
          <span :class="{'active': currentValue == item.value}" @click="handleClick(item.value)">{{item.label}}</span>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import bus from '@/bus'
export default {
  props: {
    value: {
      type: [String, Number],
      default: 0
    },
  },
  computed: {
    ...mapState('product/product', {
      filterList: state => state.filterList
    }),
    currentValue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    },
  },
  data() {
    return {}
  },
  methods: {
    handleClick(val) {
      this.currentValue = val
    },
    handlerClick() {
      this.$emit('handlerClick')
    },
    addSeries() {
      bus.$emit('addSeries')
    },
    handlerClickBanner() {
      window.open('https://www.ehang.com/')
    }
  }
}
</script>
<style lang="scss">
.product-header {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding-right: 20px;
  .logo {
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      img {
        width: 120px;
      }
      span {
        font-size: 18px;
        font-weight: 500;
        padding-left: 13px;
        margin-left: 16px;
        border-left: 1px solid rgba(32, 32, 32, 0.16);
      }
    }
    .right {
      .wf-is-plain {
        background: transparent !important;
      }
    }
  }
  .banner {
    cursor: pointer;
    img {
      height: 141px;
      width: 100%;
    }
  }
  .header-list {
    display: flex;
    align-items: center;
    span {
      padding: 6px 18px;
      font-size: 14px;
      color: rgba(32, 32, 32, 0.6);
      border-radius: 16px;
      border: 1px solid transparent;
      cursor: pointer;
      transition: all .3s;
      &:hover {
        color: initial;
      }
      &.active {
        background: rgba(2,86,255,0.16);
        border: 1px solid rgba(2,86,255,0.4);
        color: #0256FF;
      }
    }
  }
  .all {
    height: 72px;
    display: flex;
    align-items: center;
    .title {
      font-size: 16px;
      font-weight: 400;
      margin-right: 24px;
    }
  }
}
</style>
